export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '7ec4471d-3981-48e8-8457-acd50aa15537';
export const MODAL_CLOSE_SEC = 2.5;
